import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-print-icon',
  templateUrl: './print-icon.component.svg',
  styleUrls: ['./print-icon.component.css'],
})
export class PrintIconComponent {
  @Input() color!: string;
}
